import qs from "qs";
import Api from "./Api.js";
import { getBaseUrl } from "./ApiHelper.js";

const resource = "/inventories";

export default {
  skus() {
    return Api.get(`${resource}/skus`);
  },
  available(filters) {
    return Api.get(`${resource}/available`, {
      params: filters
    });
  },
  fulfillableStatus(data) {
    return Api.post(`${resource}/fulfillable/status`, data);
  },
  replacements(sku) {
    return Api.get(`${resource}/${sku}/replacements`);
  },
  products() {
    return Api.get(`inventory/products`, {
      baseURL: getBaseUrl("v2")
    });
  },
  productVariants(productId, params = {}) {
    return Api.get(`inventory/products/${productId}/variants`, {
      baseURL: getBaseUrl("v2"),
      params: params
    });
  },
  variantCountsByFacility(variantId) {
    return Api.get(`inventory/variants/${variantId}/qoh-by-facility`, {
      baseURL: getBaseUrl("v2")
    });
  },
  getVariants(filters) {
    Object.keys(filters).forEach(
      key => filters[key] == null && delete filters[key]
    );
    return Api.get(`inventory/variants`, {
      params: filters,
      paramsSerializer: filters => {
        return qs.stringify(filters, {
          arrayFormat: "brackets",
          encode: false
        });
      },
      baseURL: getBaseUrl("v2")
    });
  }
};
